import React, { useContext } from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import cls from 'classnames';
import { MyContext } from '@/config/context-manager';
import Title from '@/components/Title';
import SmallScreen from '@/components/Device/SmallScreen';
import MediumScreen from '@/components/Device/MediumScreen';
import MaxScreen from '@/components/Device/MaxScreen';
import useIsMobileNew from '@/hooks/useIsMobileNew';

const teachersConfig = [
  {
    name: '中文-老师-1-姓名',
    collegiate: '中文-老师-1-学校',
    diploma: '中文-老师-1-学历',
    img: '/images/chinese/chinese-teacher-1.png',
    classNameLi: 'col-start-1 col-end-2 flex justify-center',
    bgColor: 'bg-[#EFEBF7]',
    id: 1,
  },
  {
    name: '中文-老师-2-姓名',
    collegiate: '中文-老师-2-学校',
    diploma: '中文-老师-2-学历',
    img: '/images/chinese/chinese-teacher-2.png',
    classNameLi: 'col-start-2 col-end-3 flex justify-center',
    bgColor: 'bg-[#F0E6F0]',
    id: 2,
  },
  {
    name: '中文-老师-3-姓名',
    collegiate: '中文-老师-3-学校',
    diploma: '中文-老师-3-学历',
    img: '/images/chinese/chinese-teacher-3.png',
    classNameLi: 'col-start-2 col-end-3 flex justify-center',
    bgColor: 'bg-[#F4F0EA]',
    id: 3,
  },
  {
    name: '中文-老师-4-姓名',
    collegiate: '中文-老师-4-学校',
    diploma: '中文-老师-4-学历',
    img: '/images/chinese/chinese-teacher-4.png',
    classNameLi: 'col-start-3 col-end-3 flex justify-center',
    bgColor: 'bg-[#F5F0E9]',
    id: 4,
  },
];
// 中文-老师要求-2-标题
const teachersDemand = [
  {
    name: '中文-老师要求-1-标题',
    des: '中文-老师要求-1-描述',
    id: 1,
  },
  {
    name: '中文-老师要求-2-标题',
    des: '中文-老师要求-2-描述',
    id: 2,
  },
  {
    name: '中文-老师要求-3-标题',
    des: '中文-老师要求-3-描述',
    id: 3,
  },
  {
    name: '中文-老师要求-4-标题',
    des: '中文-老师要求-4-描述',
    id: 4,
  },
];

const Teacher = () => {
  const { t } = useTranslation(['chinese', 'path']);
  const { locale } = useContext(MyContext);
  const isEn = locale === 'en';
  const isSmallScreen = useIsMobileNew();

  return (
    <div className="container relative">
      <div className="absolute top-[30px] z-[-1] hidden h-full w-full translate-x-[-163px] lg:left-[48%] lg:block lg:h-[548px] lg:w-[669px] xl:left-[48%] xl:block xl:h-[750px] xl:w-[1038px]">
        <Image alt="WuKong" width={1038} height={750} src="/images/chinese/teacher-bg.png" quality={100} />
      </div>
      <div className={cls('lg:flex xl:flex', locale === 'zh' && 'lg:pl-[60px] xl:pl-[120px]')}>
        <div className={cls('text-left lg:w-[340px]', isEn ? 'lg:w-[390px] xl:w-[550px]' : 'xl:w-[460px]')}>
          <div className="font-light-[69.5px] text-5xl font-black leading-[69.5px] text-wk-words-1">
            <Title
              className=" relative z-20 lg:text-left [&]:lg:text-3xl [&]:lg:leading-normal [&]:xl:text-[42px] [&]:xl:leading-normal"
              innerHTML
              theme="red"
            >
              {isSmallScreen ? t('中文老师-标题-M') : t('中文老师-标题')}
            </Title>
            {/* <p className="">{t('common:seo-加入我们-关键词')}</p>
              <p className="text-wk-red-500">{t('common:seo-加入我们-关键词')}</p> */}
          </div>
          <div
            className={cls(
              'my-6 flex flex-wrap content-start justify-center gap-[20px] text-center lg:my-6 lg:h-auto lg:w-[336px] lg:justify-start xl:my-8 xl:h-[276px] xl:w-[470px] xl:justify-start',
              isEn && '[&]:lg:w-[390px] [&]:xl:h-[342px] [&]:xl:w-[550px]',
            )}
          >
            {teachersDemand.map((item) => (
              <div
                key={item.name}
                className={cls(
                  'h-[109px] w-[160px] rounded-[24px]  bg-[linear-gradient(184.23deg,rgba(255,83,83,0.03)11.74%,rgba(109,56,251,0.03)60.79%,rgba(0,157,255,0.03)90.39%),linear-gradient(180deg,rgba(255,255,255,0.4)0%,rgba(255,255,255,0.9)100%),linear-gradient(0deg,#FFFFFF,#FFFFFF)] shadow-wk1 lg:h-[96px] lg:w-[130px] lg:rounded-[17.6px] lg:bg-none xl:h-[128px] xl:w-[178px] xl:rounded-3xl xl:bg-none',
                  isEn &&
                    ' [&]:h-[128px] [&]:lg:h-[101px] [&]:lg:w-[160px] [&]:lg:px-2 [&]:xl:h-[161px] [&]:xl:w-[244px] [&]:xl:px-4',
                  isEn && item.id === 3 && '[&&]:h-[140px] [&&]:lg:h-[101px] [&&]:xl:h-[161px]',
                  isEn && item.id === 4 && '[&&]:h-[140px] [&&]:lg:h-[101px] [&&]:xl:h-[161px]',
                )}
              >
                <p
                  className="mt-5 text-[28px] font-black text-wk-words-1 lg:mb-[4px] lg:mt-[20px] lg:text-[24px] lg:leading-normal xl:mb-[8px] xl:mt-[32px] xl:text-[28px] xl:leading-[33.6px]"
                  dangerouslySetInnerHTML={{ __html: t(item?.name) }}
                />
                <p
                  className={cls(
                    'px-[12px] text-[14px] leading-[20px] text-[#6C6E83] lg:px-0 lg:text-[12px] lg:leading-normal xl:text-[16px] xl:leading-[22.4px]',
                    isEn &&
                      'flex items-center justify-center leading-[16px] lg:h-6 lg:text-[12px] xl:h-12 xl:text-[20px]',
                  )}
                >
                  {t(item?.des)}
                </p>
              </div>
            ))}
          </div>
          <h3
            className={cls(
              'text-[16px] text-wk-words-2 lg:text-[16px] lg:leading-[24px] xl:text-[20px] xl:leading-[32px]',
              isEn && '[&]:xl:text-[22px] [&]:xl:leading-8',
            )}
          >
            {t('中文-老师-介绍')}
          </h3>
        </div>
        <div
          className={cls(
            'mt-[24px] lg:mt-0 lg:w-[546px] xl:ml-[66px] xl:mt-0 xl:w-[754px]',
            locale === 'zh' ? 'lg:ml-[20px]' : 'lg:ml-[48px]',
            isSmallScreen && 'bg-[url(/images/chinese/teacher-bg-small.png)] bg-contain bg-bottom  bg-no-repeat',
          )}
        >
          <div className="">
            <ul className="relative grid grid-cols-3 grid-rows-2 lg:gap-[20px] xl:gap-[32px]">
              <SmallScreen>
                <div
                  style={{ top: isEn ? 60 : 20 }}
                  className="absolute right-[44px] top-[20px] flex h-[36px] w-[36px] rotate-[15deg] items-center justify-center rounded-[9px] border-[1px] border-solid border-white bg-[linear-gradient(135deg,rgba(255,255,255,0.56)_0%,#FFF_100%)] text-[19px] shadow-[0px_15.061px_22.82px_0px_rgba(0,0,0,0.06)]"
                >
                  🏆
                </div>
                <div
                  style={{ bottom: isEn ? 50 : 20 }}
                  className="absolute bottom-[210px] left-[70px] flex h-[22px] w-[22px] rotate-[-15deg] items-center justify-center rounded-[5px] border-[1px] border-solid border-white bg-[linear-gradient(135deg,rgba(255,255,255,0.56)_0%,#FFF_100%)] text-[14px] shadow-[2.331px_9.324px_13.986px_0px_rgba(0,0,0,0.06)]"
                >
                  🎯
                </div>
              </SmallScreen>
              <MediumScreen>
                <div
                  style={{ top: isEn ? 30 : 30 }}
                  className="absolute right-[54px] top-[10px] flex h-[50px] w-[50px] rotate-[15deg] items-center justify-center rounded-[12px] border-[1px] border-solid border-white bg-[linear-gradient(135deg,rgba(255,255,255,0.56)_0%,#FFF_100%)] text-[26px] shadow-[0px_15.061px_22.82px_0px_rgba(0,0,0,0.06)] xl:right-[120px] xl:top-[70px]"
                >
                  🏆
                </div>
                <div
                  style={{ bottom: isEn ? 60 : 40 }}
                  className="absolute left-[80px] flex  h-[50px] w-[50px] rotate-[-15deg] items-center justify-center rounded-[12px] border-[1px] border-solid border-white bg-[linear-gradient(135deg,rgba(255,255,255,0.56)_0%,#FFF_100%)] text-[26px] shadow-[2.331px_9.324px_13.986px_0px_rgba(0,0,0,0.06)]"
                >
                  🎯
                </div>
              </MediumScreen>
              <MaxScreen>
                <div
                  style={{ top: isEn ? 100 : 70 }}
                  className="absolute right-[120px] top-[70px] flex h-[80px] w-[80px] rotate-[15deg] items-center justify-center rounded-[20px] border-[1px] border-solid border-white bg-[linear-gradient(135deg,rgba(255,255,255,0.56)_0%,#FFF_100%)] text-[42px] shadow-[0px_15.061px_22.82px_0px_rgba(0,0,0,0.06)]"
                >
                  🏆
                </div>
                <div
                  style={{ bottom: isEn ? 140 : 100 }}
                  className="absolute bottom-[440px] left-[120px] flex  h-[60px] w-[60px] rotate-[-15deg] items-center justify-center rounded-[20px] border-[1px] border-solid border-white bg-[linear-gradient(135deg,rgba(255,255,255,0.56)_0%,#FFF_100%)] text-[36px] shadow-[2.331px_9.324px_13.986px_0px_rgba(0,0,0,0.06)]"
                >
                  🎯
                </div>
              </MaxScreen>
              {teachersConfig.map((item) => (
                <li
                  key={item.id}
                  className={cls(
                    item.classNameLi,
                    'xl:h-[325px] xl:w-[230px]',
                    locale !== 'en' ? 'lg:h-[214px]' : 'lg:h-[236px]',
                    item.id === 1 && 'relative top-[75px] lg:top-[115px] xl:top-[115px] xl:h-[335px]',
                    item.id === 4 && 'relative bottom-[85px] lg:bottom-[105px] xl:bottom-[105px]',
                    item.id === 3 && 'mt-[10px]',
                  )}
                >
                  <div className="relative ">
                    <div className="">
                      {/* 老师图片 */}
                      <div className={cls(`relative w-[107px] lg:w-[168px] xl:w-[230px]`)}>
                        <Image
                          className="lg: rounded-[16px_16px_0_0] lg:rounded-t-3xl xl:rounded-t-4xl"
                          alt={`${t('中文-老师-alt')} ${t(item.name)} ${t(item.collegiate)} ${!isEn && t(item.diploma)} `}
                          width={230}
                          height={220}
                          src={item.img}
                          quality={100}
                        />
                      </div>
                      {/* 信息 */}
                      <div
                        className={cls(
                          'w-[107px] rounded-b-2xl pb-[8px] pt-[6px] text-center shadow-[0px_3.65px_13.69px_0px_rgba(159,174,192,0.22)] lg:w-[168px] lg:rounded-b-3xl lg:p-[8px_4px_12px] xl:w-[230px] xl:rounded-b-4xl xl:p-[12px_4px_16px]',
                          item.bgColor,
                        )}
                      >
                        <h3
                          className={cls(
                            'text-[13px] font-semibold leading-normal text-wk-words-1 lg:text-[14px] lg:leading-normal xl:text-[20px]',
                            isEn ? ' xl:leading-[24px]' : 'xl:leading-[29px]',
                          )}
                        >
                          {t(item?.name)}
                        </h3>
                        <div className="flex flex-wrap items-center justify-center">
                          <h3
                            className={cls(
                              'block border-r-stone-300 text-[11px] leading-[13px] text-wk-words-5 lg:mt-[4px] lg:text-xs lg:leading-normal xl:mt-[6px] xl:text-base',
                              isEn ? 'xl:leading-[19px]' : 'xl:leading-[22px]',
                            )}
                          >
                            {t(item?.collegiate)}
                          </h3>
                          <p
                            className={cls(
                              'mx-[8px] mt-[6px] hidden h-[16px] w-[1px] bg-[#C6C7D2] leading-[22px] lg:hidden xl:block',
                              isEn && 'hidden lg:hidden xl:hidden',
                            )}
                          />
                          <h3
                            className={cls(
                              'text-[11px] text-wk-words-5 lg:mt-[4px]  lg:text-xs lg:leading-normal xl:mt-[6px] xl:text-base xl:leading-[22px]',
                              isEn && 'hidden',
                            )}
                          >
                            {t(item?.diploma)}
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Teacher;
